<script lang="ts" setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { faSparkles } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import SearchLeadModal from '@/components/SearchLeadModal.vue';

defineProps<{
  context?: string;
}>();

const { t } = useI18n();

const isOpen = ref(false);

const openModal = () => {
  isOpen.value = true;
};
</script>

<template>
  <div class="no-print bg-ph-green-700 my-8 rounded-lg p-6 text-center md:p-8">
    <FontAwesomeIcon :icon="faSparkles" class="text-ph-green-200 mb-3" size="2x" />
    <h3 class="2xs:text-2xl mb-2 text-xl font-semibold text-white">{{ t('views.editorial.help-widget.title') }}</h3>
    <p class="text-ph-green-100 mx-auto mb-5 max-w-2xl text-sm">{{ t('views.editorial.help-widget.description') }}</p>
    <button class="text-ph-green-800 hover:bg-ph-green-50 inline-block cursor-pointer rounded-lg bg-white px-5 py-2.5 font-semibold shadow-sm" type="button" @click="openModal">
      {{ t('views.editorial.help-widget.cta') }}
    </button>
  </div>

  <SearchLeadModal v-model:open="isOpen" :context="context" />
</template>

<style lang="css" scoped></style>
